import { routes } from '@platform/core/lib/routes';
import { recordNumber } from '@platform/engine/views/recordNumber';
import { WorkspaceLink } from '@platform/navigation/WorkspaceLink';
import type { ISearchHitRowProps } from './ISearchHitRowProps';
import { useRecordTypeLabels } from './useRecordTypeLabels';

/**
 * Рядок збігу (прототип v4 G:L2617): номер IBM Plex Mono 12px (мін. 84px; голий, як у прототипі, повне позначення — у підказці), назва 500
 * з «…», статус мовою інтерфейсу 12px; відкриває запис у його робочому просторі.
 */
export function SearchHitRow({ hit }: ISearchHitRowProps) {
  const labels = useRecordTypeLabels(hit.statusLabel ? null : hit.module, hit.recordType);
  return (
    <WorkspaceLink className="sr-row" ws={hit.workspaceId} to={routes.record(hit.module, hit.recordType, hit.recordId)}>
      <span className="sr-code" title={hit.display}>{recordNumber(hit)}</span>
      <span className="sr-title">{hit.title || hit.display}</span>
      <span className="sr-status">{hit.statusLabel || labels.status(hit.status).label}</span>
    </WorkspaceLink>
  );
}
